import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-auth`
let baseUrl2 = `${httpUrl.host}/gy-apartment`

let api = {
  // 添加角色
  add: `${baseUrl}/role/add`,

  // 修改角色
  update: `${baseUrl}/role/update`,

  // 删除角色
  deleteByCodes: `${baseUrl}/role/deleteByCodes`,

  // 获取单个角色信息
  getRoleByCode: `${baseUrl}/role/getRoleByCode`,

  // ？？？
  getPermissionsByRoleCode: `${baseUrl}/role/getPermissionsByRoleCode`,

  // 获取角色分页
  getPage: `${baseUrl}/role/getPage`,

  // 获取角色列表
  getList: `${baseUrl}/role/getList`,

  // 获取楼栋数据
  getBuildingList: `${baseUrl2}/homePage/getBuildingList`,
  // getBuildingList: `${baseUrl2}/building/getBuildingListByAccountName`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/role.js